module.exports = __webpack_public_path__ + "media/images/admin2/AdminDashboardIndex__calendar--green-f10ea134a70e3aefca732b47fce873f1.svg";